import { Stack } from "@mui/material"
import DashboardComponent from "../components/dashboard/DashboardComponent"

export default function Dashboard() {
  return (
    <>
      <div className="login-page-wrapper w-full">
        <div className="container-x mx-auto">
          <Stack alignItems={"center"} justifyContent={"center"} width={"100%"}>
            <DashboardComponent />
          </Stack>
        </div>
      </div>
    </>
  )
}

